export const blockIconsNotificationFolderSpecial = (
	<span className='material-symbols-outlined'>folder_special</span>
);
